import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import InquireCollaborate from "./sections/InquireCollaborate";
import AgencyFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <InquireCollaborate />
      <AgencyFooter />
    </div>;
}